/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do header
 */
export default styled.header`
  position: relative;
  background-color: ${({ theme }) => theme.primaryColor};
  height: 42px;
  color: white;
  display: flex;

  > svg {
    /* LOGO */
    margin: 13px 0 9px 18px;
  }

  @media (max-width: 768px) {
    display: ${({ isHided }) => (isHided ? 'none' : 'flex')};
    position: fixed;
    z-index: 1400;
    top: 0;
    right: 8px;
    background: transparent;

    > svg {
      display: none;
    }
  }

  .module_title {
    font-size: 14px;
    text-transform: uppercase;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
    margin: 10px 15px;
    padding-left: 15px;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .novidades-icon {
    display: inline-block;
    top: calc(50% - 17px);
    position: relative;
    
    @media (max-width: 768px) {
      display: none;
    }
  }

  .right_options {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    display: flex;

    ul {
      list-style: none;
      margin: 11px 15px;
      padding: 0;

      li {
        display: inline;
        font-size: 14px;
        line-height: 16px;
        padding: 0 14px;
        height: 100%;
      }
    }

    @media (max-width: 768px) {
      position: absolute;
      top: 42px;
      background: green;
    }
  }

  /* MOBILE */
  button {
    background: none;
    border: none;

    svg {
      path {
        fill: ${({ theme }) => theme.icons};
      }
    }
  }
`;

/**
 * Estilização do componente MobileLogoArea
 */
export const MobileLogoArea = styled.div`
  position: fixed;
  z-index: 1400;
  bottom: 55px;
  left: 14px;
  height: 14px;
  display: inline-flex;

  svg {
    /* LOGO DO GEOBAHIA */
    height: 12px;
    filter: drop-shadow(0px 0px 3px #000000);
  }

  .module_title {
    font-size: 11px;
    line-height: 13px;
    border-left: 1px solid rgb(255, 255, 255);
    color: #fff;
    margin: 0 0 0 6px;
    padding-left: 6px;
    text-shadow: 0px 0px 3px #000000;

    .separator {
      width: 1px;
      background: #fff;
      box-shadow: 0px 0px 3px #000000;
    }
  }

 
`;
